import { useSelector } from "react-redux";

import { ComponentListOfWinner } from "@components";
import { selectAuth } from "@redux";

export const PageListOfWinner = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentListOfWinner />
    );
};
